/* eslint-disable linebreak-style */
/* eslint-disable react/require-default-props */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable object-curly-newline */
/* eslint-disable comma-dangle */
/* eslint react/prop-types: "off" */
/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent-props */
import React from 'react';
import {
    LayoutGrid,
    FileText,
    BellRing,
    Sparkles,
    ShieldCheck,
    RefreshCw,
} from 'lucide-react';

const platformFeatures = [
    {
        id: 1,
        icon: <LayoutGrid className="w-6 h-6 text-[#459ca5]" />,
        title: 'Portfolio Dashboard',
        description: 'One unified view across all sites — electricity, water, gas, and solar. Local or remote, any device.',
    },
    {
        id: 2,
        icon: <FileText className="w-6 h-6 text-[#459ca5]" />,
        title: 'Compliance-Ready Reporting',
        description: 'Automated NABERS, Green Star, ESG and NCC reports built in. Accurate, time-stamped, ready to submit.',
    },
    {
        id: 3,
        icon: <BellRing className="w-6 h-6 text-[#459ca5]" />,
        title: 'Real-Time Alerting',
        description: 'Instant notifications for high usage, out-of-hours consumption, sensor faults and data loss events.',
    },
    {
        id: 4,
        icon: <Sparkles className="w-6 h-6 text-[#459ca5]" />,
        title: 'AI-Driven Insights',
        description: 'Detect inefficiencies, identify root causes, and act on guided recommendations — before costs escalate.',
    },
    {
        id: 5,
        icon: <ShieldCheck className="w-6 h-6 text-[#459ca5]" />,
        title: 'Secure by Design',
        description: 'Device-level VPN, HTTPS encryption, and offline data storage protect every connection across your portfolio.',
    },
    {
        id: 6,
        icon: <RefreshCw className="w-6 h-6 text-[#459ca5]" />,
        title: 'Open & Interoperable',
        description: 'Works standalone or integrates with existing BMS, HVAC, lighting and IAQ systems. No licence fees.',
    },
];

const PlatformFeatures = () => {
    return (
        <section className="w-full py-20 lg:py-24">
            <div className=" container max-w-[1440px] mx-auto px-6 lg:max-w-screen-xl">
                <div className=" mb-16">
                    <span className="text-theme-teal font-bold text-sm tracking-[0.2em] uppercase">
                        THE PLATFORM
                    </span>
                    <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 tracking-tight text-black dark:text-white">
                        Everything you need to monitor, manage and optimise energy.
                    </h2>
                    <p className="mt-6 text-base lg:text-xl text-gray-400 font-light leading-relaxed">
                        One platform. From a single site to a portfolio of 1,000+ buildings.
                        The complete energy management stack — device to dashboard.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {platformFeatures.map((feature) => (
                        <div
                            key={feature.id}
                            className="bg-white p-8 rounded-2xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow duration-300  dark:bg-theme-tarjet/70 dark:border-theme-border"
                        >
                            <div className="w-12 h-12 bg-theme-teal/20 rounded-lg flex items-center justify-center mb-6">
                                {feature.icon}
                            </div>
                            <h4 className="text-xl font-bold text-gray-900 mb-3 text-black text-base lg:text-lg dark:text-theme-teal">
                                {feature.title}
                            </h4>
                            <p className="text-gray-400 leading-relaxed font-light">
                                {feature.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PlatformFeatures;
